
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/withdrawal",
      function () {
        return require("private-next-pages/withdrawal.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/withdrawal"])
      });
    }
  